import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { BookmarkParentType } from '~/apollo/generated/v4/graphql';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const STUDY_WELL_LOGS_PAGE = graphql(`
  query StudyWellLogsPage($id: ID!) {
    studyGet(id: $id) {
      id
      wellLogs {
        ...wellLogParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
        georeferences {
          ...georeferenceParts
        }
      }
    }
  }
`);

export default function StudyWellLogsPage() {
  return (
    <ApolloProviderV4>
      <StudyWellLogsPageInner />
    </ApolloProviderV4>
  );
}

function StudyWellLogsPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(STUDY_WELL_LOGS_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    { query: STUDY_WELL_LOGS_PAGE, variables: { id: studyId } },
  ]);

  const wellLogs = data?.studyGet?.wellLogs ?? [];

  if (loading) return <SpinnerPlaceholder />;

  return (
    <SOItemListV4
      items={wellLogs}
      soParentType="study"
      soParentId={studyId}
      bookmarkParentType={BookmarkParentType.WellLog}
      refetchQueries={refetchQueries}
    />
  );
}
